import Input from 'lib/Input';
import { Label } from 'lib/Label';
import { InputSize, InputTheme } from 'components/common/types/Input.types';

type DspSeatIdProps = {
  value: string;
  onBlur: (value?: string) => void;
  isDisabled: boolean;
  isRequired: boolean;
};

const DspSeatId = ({ value, onBlur, isDisabled, isRequired }: DspSeatIdProps): React.ReactElement => {
  return (
    <>
      <Label id="dsp-seat-id" theme={InputTheme.FLAT_GRAY} label="DSP Seat ID" isRequired={isRequired} />
      <Input
        id="dsp-seat-id"
        theme={InputTheme.FLAT_GRAY}
        size={InputSize.EXTRA_SMALL}
        value={value}
        onBlur={(nextValue) => onBlur(nextValue?.toString())}
        isDisabled={isDisabled}
        isRequired={isRequired}
      />
    </>
  );
};

export default DspSeatId;
